export default "__VITE_ASSET__DWwxYhWI__"